import React, { useEffect, useState } from "react";
import { Box, Button } from "@mui/material";
import SendIcon from "../../../../images/send-arrow.svg";
import ReceiveIcon from "../../../../images/receive-arrow.svg";
import { serviceUrl } from "../../../../config";
import { useSelector } from "react-redux";
import { Tooltip } from "@mui/material";

function InternationalTransferHistory({ history, service, displayAmount = 30, trackTransaction, handleResend }) {

    const [filteredHistory, setFilteredHistory] = useState([]);

    // const BACKEND_URL = serviceUrl;
    let configVariables = useSelector((state) => state.config.baseConfig);
    let isDevEnv = configVariables.devEnvironment;

    const transactionTypes = {
        // 65: { name: "EMERLINK", type: isDevEnv ? 'send' : 'receive', icon: SendIcon, refNumber: "emerlinkrefnumber", trackableTypes: [] },
        65: { name: "EMERLINK", type: "send", icon: SendIcon, refNumber: "emerlinkrefnumber", trackableTypes: [] },
        66: { name: "EMERLINK", type: "receive", icon: ReceiveIcon, refNumber: "emerlinkrefnumber", trackableTypes: [] },
        82: { name: "RIA", type: "send", icon: SendIcon, refNumber: "riapinnumber", trackableTypes: ["1", "3"] },
        85: { name: "RIA", type: "receive", icon: ReceiveIcon, refNumber: "riapinnumber", trackableTypes: [] },
        132: { name: "BPI", type: "send", icon: SendIcon, refNumber: "confirmcode", trackableTypes: ["CASH PICKUP IN BPI BRANCH", "CREDIT TO BPI ACCOUNT", "CASH PICKUP IN OUTLET", "CASH DELIVERY", "BANK ACCOUNT"] },
        133: { name: "WESTERNUNION", type: "send", icon: SendIcon, refNumber: "confirmcode", trackableTypes: ["MONEY IN MINUTES"] },
        134: { name: "WESTERNUNION", type: "receive", icon: ReceiveIcon, refNumber: "confirmcode", trackableTypes: [] },
        141: { name: "MONEYGRAM", type: "send", icon: SendIcon, refNumber: "confirmcode", trackableTypes: ["CASH PICKUP", "BANK_DEPOSIT", "MOBILE WALLET"] },
        142: { name: "MONEYGRAM", type: "receive", icon: ReceiveIcon, refNumber: "confirmcode", trackableTypes: [] },
    };

    const showStatus = service === "MONEYGRAM";

    useEffect(() => {
        if (!history) return;
        console.log('transaction history ----------???????????', history)
        const filtered = history.filter((transaction) => {
            let data = transaction?.Useritem?.itemdata;
            const parser = new DOMParser();
            const doc = parser.parseFromString(data, "text/html");
            data = doc.documentElement.textContent;
            data = data.trim();
            if (!data) return false;
            try {
                let parsedData = JSON.parse(data);
                // Handle double-encoded itemdata (e.g. today's transactions):
                // first JSON.parse returns a string instead of an object,
                // so we parse once more to get the actual object.
                if (typeof parsedData === "string") {
                    parsedData = JSON.parse(parsedData);
                }
                const transactionType = parsedData?.transtype;
                return transactionTypes[transactionType]?.name === service;
            } catch (err) {
                return false;
            }
        });

        setFilteredHistory(filtered);
    }, [history, service]);

    const decodeHtml = (html) => {
        const txt = document.createElement("textarea");
        txt.innerHTML = html;
        return txt.value;
    };

    const formatDeliveryMethod = (value) => {
        if (!value) return "-";
        return value
            .toString()
            .replace(/_/g, " ")
            .toLowerCase()
            .replace(/\b\w/g, (c) => c.toUpperCase());
    };

    return (
        <Box
        sx={{
            height: '200px',
            overflowY: 'auto',
          }}
          >

           <Box
    display="flex"
    sx={{
        position: 'sticky',
        top: 0,
        backgroundColor: '#fff',
        zIndex: 1,
        borderBottom: "1px solid #ccc",
        height: "40px",
        fontWeight: "bold"
    }}
    alignItems="center"
>
    <Box flex={1}></Box>
    <Box flex={3}>Name</Box>
    <Box flex={2}>Ref Number</Box>
    <Box flex={2}>Date</Box>
    {showStatus && <Box flex={2} sx={{ paddingLeft: 1, paddingRight: 1 }} >Status</Box>}
    {showStatus && <Box flex={2} sx={{ paddingLeft: 1, paddingRight: 1 }} >Type</Box>}   {/* ← new line goes here */}
    <Box flex={2} display="flex" justifyContent="center"></Box>
    <Box flex={1}>Amount</Box>
    <Box flex={1}></Box>
</Box>

            {filteredHistory?.slice(0, displayAmount).map((row, index) => {
                let data = row?.Useritem?.itemdata;
                // console.log("row?.Useritem===========",row?.Useritem);
                const parser = new DOMParser();
                const doc = parser.parseFromString(data, "text/html");
                data = doc.documentElement.textContent;
                let date = row.Useritem.creationdate.replaceAll(" ", 'T');
                date = new Date(date);
                date = date.toDateString();

                // Handle double-encoded itemdata: if first parse returns a string,
                // parse once more to get the actual object. Keep `data` as a
                // valid JSON string so handleResend/trackTransaction can JSON.parse
                // it downstream and receive a plain object — same as old behaviour.
                let parsedData = JSON.parse(data);
                if (typeof parsedData === "string") {
                    data = parsedData;           // unwrap to inner JSON string
                    parsedData = JSON.parse(data); // now a plain object
                }

                const incomingTransType = parsedData?.transtype;
                // console.log("incomingTransType==========",incomingTransType);
                const transactionType = transactionTypes[incomingTransType];
                // console.log("transactionType==========",transactionType);
                if (!transactionType) return null;
                const icon = transactionType.icon;
                const type = transactionType.type;
                let name = (type === 'send' ? parsedData.recipientname : parsedData.sendername) ?? parsedData.receivername ?? parsedData.recipientname;
                if (service === "MONEYGRAM") {
                    name = decodeHtml(name);
                }
                const refNumber = parsedData[transactionType.refNumber];
                // console.log("refNumber==========",refNumber);
                const totalamount = parseFloat(parsedData.totalamount).toFixed(2);
                let trackValue = null;

                if (parsedData?.deliverymethodid) {
                    // 1. RIA: deliverymethodid
                    trackValue = parsedData.deliverymethodid;
                } else if (parsedData?.transactionDetails) {
                    // 2. MoneyGram: deliveryoption is inside transactionDetails
                    try {
                        const txDetails = JSON.parse(parsedData.transactionDetails);
                        if (txDetails?.deliveryoption) {
                        const deliveryOpt = JSON.parse(txDetails.deliveryoption); // double parse!
                        trackValue = deliveryOpt.deliveryOptDisplayName || deliveryOpt.deliveryOption || "";
                        }
                    } catch (e) {
                        console.warn("Failed to parse transactionDetails.deliveryoption", e);
                    }
                } else if (service == "BPI") {
                    trackValue = parsedData?.payoutmethodName;
                    
                } else {
                    // 3. Fallback
                    trackValue = parsedData.payoutmethod || "";
                }

                const canTrack = type === 'send' && 
                    transactionType?.trackableTypes?.some(method => 
                    trackValue?.toString().toUpperCase().includes(method)
                );

                return (
                    <Box
                        key={index}
                        display="flex"
                        style={{
                            borderBottom: "1px solid #ccc",
                            height: "50px"
                        }}
                        alignItems="center"
                    >
                        <Box
                            flex={1}
                        >
                            <img
                                src={icon}
                                alt={type}
                                style={{ height: "50%", maxWidth: "100%" }}
                                loading="lazy"
                            />
                        </Box>
                        <Box className="small fw-bold" flex={3}>{name}</Box>
                        <Box className="small" flex={2}>{refNumber}</Box>
                        <Box className="small" flex={2}>{date}</Box>
                        {showStatus && <Box className="small" flex={2} sx={{ paddingLeft: 2, paddingRight: 2 }}>{row.Useritem.lookup3}</Box>}
                       {showStatus && (
    <Tooltip title={formatDeliveryMethod(trackValue)}>
        <Box
            className="small"
            flex={2}
            sx={{
                paddingLeft: 1,
                paddingRight: 1,
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
            }}
        >
            {formatDeliveryMethod(trackValue)}
        </Box>
    </Tooltip>
)}
                        {/* <Box
                            flex={2}
                            display="flex" justifyContent="center">
                            {type === 'send'  && service !== 'MONEYGRAM' ?
                                <Button
                                    className="w-50 fs-size-12 paiy-blue text-white border-50-round"
                                    sx={{ textTransform: 'none', padding: '0px' }}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        handleResend(data);
                                    }}
                                >
                                    Resend
                                </Button>
                                : ''
                            }
                        </Box> */}
                        {/* for CAKE 5 TESTING ONLY */}
                         <Box
                            flex={2}
                            display="flex" justifyContent="center">
                            {type === 'send'  && service !== 'MONEYGRAM' ?
                                <Button
                                    className="w-50 fs-size-12 paiy-blue text-white border-50-round"
                                    sx={{ textTransform: 'none', padding: '0px' }}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        handleResend(data);
                                    }}
                                >
                                    Resend
                                </Button>
                                : ''
                            }
                        </Box>
                        <Box className="small fw-bold" flex={1}>${totalamount}</Box>
                        <Box flex={1}>
                        {canTrack && <Button
                            className="w-50 fs-size-12 paiy-blue text-white border-50-round"
                            sx={{ textTransform: 'none' }}
                            onClick={(e) => {
                                e.stopPropagation();
                                trackTransaction(refNumber, data);
                            }}
                        >
                            Track
                        </Button>}
                        </Box>

                    </Box>
                );
            })}
        </Box>
    );
}

export default InternationalTransferHistory;
